import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { MobileMixin } from './MobileMixin.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';


export const FacebookMessengerLink = createReactClass({
    propTypes: {
        urlToShare: PropTypes.string.isRequired,
        projectId: PropTypes.num,
        getTrackingLink: PropTypes.func.isRequired,
        facebookAppId: PropTypes.string.isRequired,
        className: PropTypes.string,
        closeAfterShare: PropTypes.bool,
        pageName: PropTypes.String,
        children: PropTypes.any.isRequired,
    },

    mixins: [MobileMixin],

    getDefaultProps: function () {
        return {
            closeAfterShare: false,
        };
    },

    handleClickEvent: function() {
        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.urlToShare, 'Facebook Messenger');
        trackShareToolClick(this.props.projectId, SHARE_TOOLS.FACEBOOK_MESSENGER);
    },

    getFacebookMessengerUrl: function () {
        var trackingLink = this.props.getTrackingLink(this.props.urlToShare, 'fbmessenger', this.props.pageName);
        if (this.state.isMobile) {
            return 'fb-messenger://share/?app_id=' + this.props.facebookAppId + '&link=' + trackingLink;
        } else {
            return 'https://www.facebook.com/dialog/send?app_id=' + this.props.facebookAppId +
                '&link=' + trackingLink + (this.props.closeAfterShare ? '' : '&redirect_uri=' + trackingLink);
        }
    },

    render: function () {
        return (
            <a href={this.getFacebookMessengerUrl()} target="_blank" aria-label="Share via Facebook Messenger" className={this.props.className} onClick={this.handleClickEvent}>
                {this.props.children}
            </a>

        );
    },
});
